import React from 'react';
import { DropZone } from '@measured/puck';
import { backgroundColorOptions } from './theme/colors';

const CtaCallToActionComponent = ({
  title = 'Get started',
  description = 'Browse the Puck GitHub to get started, or try editing this page.',
  background = 'white',
  alignment = 'center'
}) => {
  // Removed color resolution - now using Tailwind dark mode classes

  const getAlignmentClass = () => {
    switch (alignment) {
      case 'left':
        return 'items-start text-left';
      case 'right':
        return 'items-end text-right';
      default:
        return 'items-center text-center';
    }
  };

  return (
    <section className="w-full py-20 sm:py-24 bg-white dark:bg-slate-900">
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className={`flex flex-col gap-7 sm:gap-10 ${getAlignmentClass()}`}>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold text-slate-900 dark:text-slate-100">
            {title}
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-slate-600 dark:text-slate-300">
            {description}
          </p>

          <DropZone zone="cta-content" className="w-full" />
        </div>
      </div>
    </section>
  );
};

export const CtaCallToAction = {
  fields: {
    title: {
      type: 'text',
      label: 'Titel'
    },
    description: {
      type: 'textarea',
      label: 'Beschreibung'
    },
    background: {
      type: 'select',
      label: 'Hintergrund',
      options: backgroundColorOptions()
    },
    alignment: {
      type: 'select',
      label: 'Ausrichtung',
      options: [
        { label: 'Zentriert', value: 'center' },
        { label: 'Links', value: 'left' },
        { label: 'Rechts', value: 'right' }
      ]
    }
  },
  defaultProps: {
    title: 'Get started',
    description: 'Browse the Puck GitHub to get started, or try editing this page.',
    background: 'white',
    alignment: 'center'
  },
  render: CtaCallToActionComponent
};
